module.exports = __webpack_public_path__ + "fonts/TribalIcons.7dc7267.eot";